import { jsx as _jsx } from "react/jsx-runtime";
import { SDUILayoutSectionRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/LayoutSection/SDUILayoutSectionRenderer";
import { ISection } from "@faire/web-api--source/indigofair/data/ISection";
import React from "react";
export var ComponentsFlowLayoutSection = function(param) {
    var filteredComponents = param.filteredComponents, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData;
    var section = ISection.build({
        layout_section: {
            components: filteredComponents.components,
            layout: filteredComponents.layout
        }
    });
    return /*#__PURE__*/ _jsx(SDUILayoutSectionRenderer, {
        section: section,
        componentRenderers: componentRenderers,
        sectionLoggingData: sectionLoggingData
    });
};
